<template>
  <tr v-if="$parent.$parent.$parent.rerender">
    <td>{{ index + 1 }}</td>
    <td
      v-bind:class="{
        'has-error': $parent.hasError(index, 'UF_VID_GROUP_ID')
      }"
    >
      <input type="hidden" v-model="item.ID" />
      <select
        @change="$parent.removeError(index, 'UF_VID_GROUP_ID')"
        v-model="item.UF_VID_GROUP_ID"
        class="sel-dropdown i-main-style "
        :disabled="$parent.$parent.$parent.projectDisabled"
      >
        <option
          v-for="g in $parent.directory.tree_group_med_oborudovanie"
          v-bind:value="g.ID"
          v-bind:key="g.ID"
          v-if="
            g.UF_SUPPORT_PROGRAM_ID.indexOf(project.UF_SUPPORT_PROG_ID) >= 0
          "
          v-text="g.NAME"
        ></option>
      </select>
      <div class="error-text"></div>
    </td>
    <td>{{ cGroupCode }}</td>
    <td
      v-bind:class="{
        'has-error': $parent.hasError(index, 'UF_VID_ID')
      }"
    >
      <select
        @change="$parent.removeError(index, 'UF_VID_ID')"
        v-model="item.UF_VID_ID"
        class="sel-dropdown i-main-style "
        style="width: 300px"
        :disabled="$parent.$parent.$parent.projectDisabled"
      >
        <option
          v-for="g in cGroup"
          v-bind:value="g.ID"
          v-bind:key="g.ID"
          v-text="g.NAME"
        ></option>
      </select>
      <div class="error-text"></div>
    </td>
    <td
      v-bind:class="{
        'has-error': $parent.hasError(index, 'UF_DESCRIPTION')
      }"
      style="
          padding-top: 10px;
        "
    >
      <textarea
        @keyup="$parent.removeError(index, 'UF_DESCRIPTION')"
        v-model="item.UF_DESCRIPTION"
        class="i-main-style t-co-executor-style"
        :disabled="$parent.$parent.$parent.projectDisabled"
      ></textarea>
      <span class="frp-input-description"
        >Доступно для ввода символов:
        {{ countEntChar(item.UF_DESCRIPTION, 200) }}
      </span>
      <div class="error-text"></div>
    </td>
    <td>
      от
      <input
        class="i-main-style i-wid-29"
        @keypress="isNumber($event)"
        v-model="item.UF_COUNT_FROM"
      />
      до
      <input
        class="i-main-style i-wid-29"
        @keypress="isNumber($event)"
        v-model="item.UF_COUNT_TO"
      />
    </td>
    <td>
      <a
        v-show="!$parent.$parent.$parent.projectDisabled"
        v-on:click="$parent.deleteItem(index)"
        class="link-delete-row"
      ></a>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["item", "index"],
  name: "system_equipment_list",
  methods: {
    isNumber(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    countEntChar(value, limit) {
      if (value) {
        const length = String(value).length;
        return length > limit ? 0 : limit - length;
      }
      return limit;
    }
  },
  computed: {
    ...mapGetters(["project"]),
    cGroup() {
      if (this.item.UF_VID_GROUP_ID < 1) {
        return [];
      }
      let t = this.$parent.directory.tree_group_med_oborudovanie.filter(
        c => c.ID === this.item.UF_VID_GROUP_ID
      );
      if (t.length > 0) {
        return t[0].CHILD;
      }
      return [];
    },
    cGroupCode() {
      let t = null;
      t = this.$parent.directory.tree_group_med_oborudovanie.filter(
        c => c.ID === this.item.UF_VID_GROUP_ID && c.UF_IS_SET_BLOCK_FIELD === 0
      );
      if (t.length > 0) {
        let tv = null;
        console.log(t);
        tv = t[0].CHILD.filter(c => c.ID === this.item.UF_VID_ID);
        if (tv.length) return tv[0].CODE;
      }
      return "";
    }
  }
};
</script>

<style scoped></style>
